import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = { class: "font--fancy" }
const _hoisted_3 = { id: "homeNav" }
const _hoisted_4 = { id: "logo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "logoText" }, "ManaBase.app", -1)
const _hoisted_6 = { class: "font--fancy" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "linkName" }, "Search", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "linkName" }, "Lists", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "linkName" }, "Cycles", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "linkName" }, "Info", -1)
const _hoisted_11 = { id: "main" }
const _hoisted_12 = { id: "logo2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", {
  id: "title",
  class: "font--fancy"
}, "ManaBase.app", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", {
  id: "subtitle",
  class: "font--fancy"
}, "Discover new lands for your Commander decks", -1)
const _hoisted_15 = {
  key: 0,
  class: "font--fancy"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Working on: ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("footer", null, " Content on ManaBase.app is provided under the Wizards of the Coast Fan Content Policy. The rights to any card imagery presented herein are retained by their respective owners. Symbols, card data, and associated iconography are owned by Wizards of the Coast. ManaBase.app is provided 'as-is' and makes no warranties or guarantees of performance or consistency. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            exact: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_inline_svg, {
                  src: require(`@/assets/icons/land.svg`)
                }, null, 8, ["src"])
              ]),
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            exact: ""
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_inline_svg, {
                src: require(`@/assets/icons/land.svg`)
              }, null, 8, ["src"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          (_ctx.state.listsEnabled)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/lists"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_font_awesome_icon, { icon: ['far', 'scroll-old'] })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/cycles" }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_font_awesome_icon, { icon: ['far', 'circle-notch'] })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createVNode(_component_font_awesome_icon, { icon: ['far', 'question'] })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_inline_svg, {
          src: require(`@/assets/icons/land.svg`)
        }, null, 8, ["src"])
      ]),
      _hoisted_13,
      _hoisted_14,
      (_ctx.state.currentManaList && _ctx.state.listsEnabled)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_router_link, {
              to: `/lists/${_ctx.state.currentManaList.id}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.currentManaList.id), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      _hoisted_17
    ])
  ], 64))
}